export function distNm(lat1, lon1, lat2, lon2) {
  const R = 3440.065;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dLat/2)**2 + Math.cos(lat1*Math.PI/180)*Math.cos(lat2*Math.PI/180)*Math.sin(dLon/2)**2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
}
export function bearing(lat1, lon1, lat2, lon2) {
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const y = Math.sin(dLon) * Math.cos(lat2 * Math.PI / 180);
  const x = Math.cos(lat1*Math.PI/180)*Math.sin(lat2*Math.PI/180) - Math.sin(lat1*Math.PI/180)*Math.cos(lat2*Math.PI/180)*Math.cos(dLon);
  return ((Math.atan2(y, x) * 180 / Math.PI) + 360) % 360;
}
export function crossTrackFt(ptLat, ptLon, rwLat, rwLon, rwHdg) {
  const d = distNm(rwLat, rwLon, ptLat, ptLon) * 6076.12;
  const brg = bearing(rwLat, rwLon, ptLat, ptLon);
  const angle = (brg - rwHdg - 180) * Math.PI / 180;
  return d * Math.sin(angle);
}
// Custom image icons for skill chips, keyed by the emoji each icon map emits.
// Icon strings without an image pass through unchanged, so unpatched render
// sites degrade gracefully to the emoji.
const SKILL_ICON_IMAGES = {
  '🌬️': ['/crosswind-icon.png', 'Crosswind'],
  '💨': ['/gust-icon.png', 'Gust'],
  '🌙': ['/night-icon.png', 'Night Flight'],
  '🧭': ['/ifr-icon.png', 'IFR'],
  '🔴': ['/ifr-icon.png', 'LIFR'],
  '⚡': ['/gust-icon.png', 'Windshear'],
  '🛬': ['/shortfield-icon.png', 'Short Field'],
  '🏔️': ['/highalt-icon.png', 'High Altitude Ops'],
};
export function renderSkillIcon(ic) {
  const hit = SKILL_ICON_IMAGES[ic];
  if (hit) {
    return <img src={hit[0]} alt={hit[1]}
      style={{ height: '1.15em', verticalAlign: '-0.18em', borderRadius: 3 }} />;
  }
  return ic;
}

const SKILL_ICONS = {
  'Crosswind': '🌬️', 'Gust': '💨', 'Windshear': '⚡', 'Night Flight': '🌙',
  'IFR': '🧭', 'LIFR': '🔴', 'Short Field': '🛬', 'High Altitude Ops': '🏔️',
};

export function deriveSkillIcons(f) {
  // Prefer real pipeline skill tags (skills_json) when the row carries them
  const tags = (f.skills_json || []).map(s => s && s.skill).filter(Boolean);
  if (tags.length) return tags.map(t => SKILL_ICONS[t] || '🎯');
  // Fallback for rows without skills_json: derive from wind columns
  const icons = [];
  const wind = f.wind_speed_kt || 0;
  const gust = f.wind_gust_kt || 0;
  const xwind = f.crosswind_kt || 0;
  if (gust > 0 && (gust - wind) >= 15) icons.push('⚡');
  else if (gust > 0) icons.push('💨');
  if (xwind > 5) icons.push('🌬️');
  return icons;
}
